import api from "!../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../css-loader/dist/cjs.js??ruleSet[1].rules[97].oneOf[1].use[1]!../postcss-loader/dist/cjs.js??ruleSet[1].rules[97].oneOf[1].use[2]!./swiper.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};